/* esm.sh - applesauce-common@5.2.0/dist/blueprints/comment */
export * from "/*applesauce-common@5.2.0/esnext/dist/blueprints/comment.mjs";
